import type { QuizsetFolderCursorSearchReq } from '@/api/gen/_model/quizsetFolderCursorSearchReq';
import { searchPublic } from '@/api/gen/quizset-folder-controller/quizset-folder-controller.gen';
import { followEmptyCursorPages } from '@/shared/utils/followEmptyCursorPages';

import { toFolderFromSearch } from '../folder.adapters';

import type { FolderSearchPage } from './folder';

/**
 * 남의 프로필에 보이는 공개 폴더 한 페이지 (`POST /users/{userId}/quizset-folders/search`).
 * 비공개 폴더는 서버가 거른다. 요청·응답은 내 폴더 검색과 같은 스키마다.
 *
 * 내 폴더 검색과 달리 검색 인덱스 지연 보정을 거치지 않는다 — 그 보정은 이 세션에서 내가 바꾼 폴더를 **내** 목록에
 * 맞추는 장치라 남의 목록에는 맞지 않는다.
 */
export const searchUserFolders = async (
  userId: string,
  variables: Omit<QuizsetFolderCursorSearchReq, 'cursor'>,
  cursor?: string,
  signal?: AbortSignal,
): Promise<FolderSearchPage> => {
  const response = await followEmptyCursorPages(
    pageCursor =>
      searchPublic(
        userId,
        { ...variables, cursor: pageCursor },
        undefined,
        signal,
      ),
    cursor,
  );

  return {
    items: response.data.map(toFolderFromSearch),
    nextCursor: response.nextCursor,
    hasNext: response.hasNext,
    totalCount: response.totalCount,
  };
};
